export function storeSigningIntent<TContext>(
  payload: TContext,
  params: {
    pathParams?: Record<string, string>
    queryParams?: Record<string, unknown>
    signer_name: string
    reason?: string
    [key: string]: unknown
  },
) {
  localStorage.setItem('signing_payload', JSON.stringify(payload))
  localStorage.setItem('signing_params', JSON.stringify(params))
}
